var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-row',{staticClass:"mx-2",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"mt-6",attrs:{"cols":"12"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }